import React from 'react';
import { RangeBlocks, useTheme } from '../../../../../../base-components';
import { IActiveFilter } from '../../../../../table.interfaces';
import {
    createScoreRangeConfig,
    IRangeBlocksValues,
    ScoreRange,
} from '../../../../../../../common';
import { MenuContainer } from './scoreRangeMenu.styles';

interface ScoreRangeMenuProps {
    activeFilterIndex: number;
    activeFilters: Array<IActiveFilter>;
    customRanges?: ScoreRange[];
    onChange: (newValue: IRangeBlocksValues) => void;
}

const ScoreRangeMenu: React.FC<ScoreRangeMenuProps> = ({
    activeFilterIndex,
    activeFilters,
    customRanges,
    onChange,
}) => {
    const theme = useTheme();

    const scoreRangeConfig = createScoreRangeConfig(customRanges);

    const currentValue = activeFilters[activeFilterIndex].values as [
        number,
        number,
    ];
    console.log(`this is the current value ${currentValue}`);
    return (
        <MenuContainer>
            <RangeBlocks
                externalValue={{
                    from: currentValue[0] || 0,
                    to: currentValue[1] || 0,
                }}
                onChange={onChange}
                fillColor={theme.palette.success.main}
                backgroundColor={theme.palette.grey[300]}
                disabled={false}
                showSelectionText={true}
                scoreRangeConfig={scoreRangeConfig}
            />
        </MenuContainer>
    );
};

export default ScoreRangeMenu;
